import axios, { AxiosInstance, AxiosError, AxiosRequestConfig } from 'axios';
import { ORDER_TYPE_STORE_COUNTER } from '../Utils/Constants/Service';

// Extensão da interface para incluir a propriedade _retry
interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  _retry?: boolean; // Propriedade opcional
}

export default class BaseService {
  orderType: string;
  token?: string;
  guestToken?: string;
  http: AxiosInstance;

  constructor(orderType: string, token: string = '', guestToken: string = '') {
    this.orderType = orderType;
    this.token = token;
    this.guestToken = guestToken;
    this.http = this.createApiInstance();

    this.http.interceptors.response.use(
      response => response,
      async (error: AxiosError) => {
        const originalRequest = error.config as CustomAxiosRequestConfig;

        // Verifica se o erro é devido a token expirado
        if (error.response && error.response.status === 401 && originalRequest && !originalRequest._retry) {
          originalRequest._retry = true;

          if (!originalRequest.headers) {
            originalRequest.headers = {};
          }

          try {
            if (this.token) {
              const newToken = await this.refreshToken(token);
              if (newToken) {
                this.token = newToken;
                localStorage.setItem('token', newToken);
                originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
                return this.http(originalRequest);
              }
            } else if (this.guestToken) {
              const newGuestToken = await this.refreshGuestToken(token);
              if (newGuestToken) {
                this.guestToken = newGuestToken;
                localStorage.setItem('guest_token', newGuestToken);
                originalRequest.headers['Guest-Token'] = `${newGuestToken}`;
                return this.http(originalRequest);
              }
            }

          } catch (refreshError) {
              return Promise.reject(refreshError);
          }
        }

        return Promise.reject(error);
      }
    )
  }

  createApiInstance(): AxiosInstance {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json'
    };

    if (this.token) {
      headers['Authorization'] = `Bearer ${this.token}`;
    }

    if (this.guestToken) {
      headers['Guest-Token'] = `${this.guestToken}`;
    }

    return axios.create({
      baseURL: this.getApiBaseUrl(),
      headers: headers,
    });
  }

  getApiBaseUrl(): string {
    switch (this.orderType) {
      case ORDER_TYPE_STORE_COUNTER:
        return 'https://pdv-hml-2.shopfood.io/v2';
      default:
        return 'https://api-hml-2.shopfood.io/v2';
    }
  }

  async refreshToken(token: string): Promise<string> {
    const response = await this.http.post('/auth/refresh', {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data.token;
  }

  async refreshGuestToken(token: string): Promise<string> {
    const response = await this.http.post('/auth/refresh', {}, {
      headers: {
        'Guest-Token': `${token}`
      }
    });
    return response.data.token;
  }

}
